const baseDomain = process.env.REACT_APP_API_BASE ? process.env.REACT_APP_API_BASE : 'portal.odore.co.uk';

export const BASE_API_URL = `${baseDomain}/`; // prod

export const API_CALL = 'API_CALL';

export const ACCESS_OWNER = 'owner';
export const ACCESS_EMPLOYEE = 'employee';
export const ACCESS_CONTENT_MANAGER = 'content_manager';